import Vue from 'vue'
import App from './App.vue'
import router from './router'
import auth from './store/auth'
import trial from './store/trial'
import toast from './store/toast'
import catalog from './store/catalog'
import { platform } from './services/platform'
import { findRechargeOrderIdByOrderNumber } from './services/recharge'
import './assets/style/reset.css'
import './assets/style/global.less'

Vue.config.productionTip = false
// 关键节点：把全局登录能力挂到 Vue 实例，页面入口可直接调用
Vue.prototype.$auth = auth
// 关键节点：把全局试用流程挂到 Vue 实例，所有免费试用入口统一调用
Vue.prototype.$trial = trial
// 关键节点：把全局提示能力挂到 Vue 实例，页面和组件统一调用
Vue.prototype.$toast = toast.show
// 关键节点：应用挂载前预加载商品目录；请求失败不阻塞启动，消费者访问时会自动重试。
catalog.initializeCatalog().catch(() => {})

// 关键节点：支付宝同步回跳参数位于 hash 路由之前，应用启动时先恢复对应订单。
// 优先匹配本地充值意图；未命中时查询订单列表，普通订单同样进入结果页。
const alipayOrderNumber = new URLSearchParams(window.location.search).get('out_trade_no') || ''

// 方法：按支付宝商户订单号查找本地订单 ID（充值意图优先，其次订单列表）
async function resolveOrderIdByOrderNumber(orderNumber) {
  const rechargeOrderId = findRechargeOrderIdByOrderNumber(orderNumber)
  if (rechargeOrderId) {
    return rechargeOrderId
  }
  try {
    const orders = await platform.orders()
    const list = Array.isArray(orders) ? orders : ((orders && orders.items) || [])
    const matched = list.find(order => order && order.order_number === orderNumber)
    return (matched && matched.id) || ''
  } catch (error) {
    // 逻辑分支：订单查询失败时回到首页，用户可自行在个人中心查看订单。
    return ''
  }
}

async function bootstrap() {
  if (alipayOrderNumber) {
    // 逻辑分支：挂载前替换为结果页 hash，同时移除查询串，避免 Router 初始化覆盖回跳目标。
    const alipayReturnOrderId = await resolveOrderIdByOrderNumber(alipayOrderNumber)
    if (alipayReturnOrderId) {
      const paymentResultHref = router.resolve({
        name: 'payment-result',
        params: { orderId: alipayReturnOrderId }
      }).href
      window.history.replaceState(null, document.title, `${window.location.pathname}${paymentResultHref}`)
    }
  }

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()
